module.exports = __webpack_public_path__ + "f8190356858c9e44666a7c5bcdc123d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/footer/images/footer-logo.png
// module id = 392
// module chunks = 0 1 2 3